import { Component, Input, OnInit } from '@angular/core';
import { head, map, forEach, find, isEmpty } from 'lodash';
import * as moment from 'moment';
import { ClickListItemComponent } from '../click-list-item/click-list-item.component';
@Component({
  selector: "auditing",
  template: `
    <i
      *ngIf="filledData && filledData.length > 0"
      class="icon icon-{{ auditIcon }} color-{{ getType() }}"
    ></i>

    <div
      *ngIf="filledData && filledData.length > 0"
      class="filled-data-popover"
      [ngClass]="{
        default: auditIcon == 'default',
        complex: whatsMyType(filledData) === 'object'
      }"
    >
      <ng-container *ngIf="whatsMyType(filledData) === 'object'; else simple"><!-- Complex control -->
        <span
          *ngFor="let item of filledData"
          class="color-{{ item.color }} value-item"
        >
          <ng-container *ngIf="item.name">{{ item.name }}  :</ng-container> {{ changeBooleanValue(item.text) }}
        </span>
      </ng-container>

      <ng-template #simple><!-- Simple control -->
        <span>
          {{ changeBooleanValue(filledData) }}
        </span>
      </ng-template>
      <div class="indicator-text">{{ indicator }}</div>
      <p *ngIf="auditIcon == 'default'">
        please verify with <br />
        the customer.
      </p>
    </div>
  `,
  styleUrls: ['./auditing.component.scss']
})
export class AuditingComponent implements OnInit {
  @Input() filledData: any;
  @Input() type: string;
  @Input() auditIcon: string;
  @Input() indicator: string;

  constructor() {}

  async ngOnInit() {}

  whatsMyType(data) {
    return typeof data;
  }

  getType() {
    return this.whatsMyType(this.filledData) === 'object'
      ? this.getComplexType()
      : this.type;
  }

  getColorPriority(color)
  {
      if(color == 'green')
        return 0;
      else if(color == 'yellow')
        return 1;
        else return 10;
  }

  getComplexType() {
    var color = "";

    this.filledData.forEach(item => {
      if(this.getColorPriority(color) > this.getColorPriority(item.color))
        color = item.color;
    });

    return color; 
  }

  // sortdates(a, b) {
  //   return moment(a).isAfter(b) ? b : a;
  // }

  changeBooleanValue(val) {
    if (val.toLowerCase() === 'true') {
      return 'Yes';
    } else if (val.toLowerCase() === 'false') {
      return 'No';
    } else {
      return val;
    }
  }
}
